
import {createI18n} from 'vue-i18n'
// import en from '@/locales/config/en.json'
import messages from '@/locales/index.js'


let lang = localStorage.getItem('language') || 'en'




/**
 * For Vue
 */
const localData = {
  globalInjection: true, //$t
  legacy : false, //Options api false
  locale : lang,
  // allowComposition: true,
  fallbackLocale: 'en', // 若該語語系有缺，則用en當預設語系
  messages,
}
export function setupI18n(app){ 
  const i18n = createI18n(localData)
  app.use(i18n)
}

/**
 * Pure javascript 
 */
const i18n = createI18n({
  locale: lang,
  allowComposition: true, // you need to specify that!
  messages
})

export default i18n